import {
  BUSINESS_NAME_MAX_LENGTH,
  EMAIL_REGEX,
  PROFILE_NAME_MAX_LENGTH,
  REGISTRATION_NUMBER_MAX_LENGTH,
} from '@pulsify/shared/validation'
import { z } from 'zod'
import * as m from '~/paraglide/messages'

export const adminLoginSchema = z.object({
  email: z.string().trim().regex(EMAIL_REGEX, m.invalidEmailAddress()),
  password: z.string().min(1, m.passwordRequired()),
})

export const adminUserSchema = z.object({
  userId: z.string(),
  email: z.string(),
  roles: z.string(),
  additionalClaims: z
    .array(
      z.object({
        type: z.string(),
        value: z.string(),
      }),
    )
    .optional(),
})

export type AdminUser = z.infer<typeof adminUserSchema>

export const businessListItemSchema = z.object({
  id: z.string(),
  legalName: z.string(),
})

export type BusinessListItem = z.infer<typeof businessListItemSchema>

export const inviteBusinessSchema = z.object({
  firstName: z.string().trim().min(1, m.firstNameRequired()).max(PROFILE_NAME_MAX_LENGTH),
  lastName: z.string().trim().min(1, m.lastNameRequired()).max(PROFILE_NAME_MAX_LENGTH),
  email: z.string().trim().regex(EMAIL_REGEX, m.invalidEmailAddress()),
  companyName: z.string().trim().min(1, m.tradeNameRequired()).max(BUSINESS_NAME_MAX_LENGTH),
  legalName: z.string().trim().min(1, m.legalNameRequired()).max(BUSINESS_NAME_MAX_LENGTH),
  registrationNumber: z
    .string()
    .trim()
    .min(1, m.registrationNumberRequired())
    .max(REGISTRATION_NUMBER_MAX_LENGTH),
})

/**
 * Wire shape for the invite request: `registrationNumber` is nullable because a
 * club has none, matching `inviteBusinessRequestSchema` in @pulsify/shared.
 * `inviteBusinessSchema` above stays required - it is the form gate, and the
 * club path omits the field from it rather than inventing a placeholder.
 */
export const inviteBusinessInputSchema = inviteBusinessSchema.extend({
  registrationNumber: z.string().trim().max(REGISTRATION_NUMBER_MAX_LENGTH).nullable(),
})

export type InviteBusinessInput = z.infer<typeof inviteBusinessInputSchema>

export const inviteBusinessResponseSchema = z.object({
  businessId: z.string(),
  existingAccount: z.boolean(),
  notificationSent: z.boolean(),
})

export type InviteBusinessResponse = z.infer<typeof inviteBusinessResponseSchema>
